module.exports = __webpack_public_path__ + "img/ccwl-1.1375267e.png";